// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PFixEntitlementSubscriptionRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_PRODUCT_SUBSCRIPTION_MANAGEMENT_REQ, fieldSet);
    }
    getProductId() {
        return this.getFieldValue(FieldsFactory.FIELD_PRODUCT_ID);
    }
    setProductId(value) {
        this.setFieldValue(FieldsFactory.FIELD_PRODUCT_ID, value);
    }
    getRequestType() {
        return this.getFieldValue(FieldsFactory.FIELD_PRODUCT_REQUEST_TYPE);
    }
    setRequestType(value) {
        this.setFieldValue(FieldsFactory.FIELD_PRODUCT_REQUEST_TYPE, value);
    }
    AddDocument(documentGroup) {
        this.FieldSet.AddGroup(documentGroup);
    }
}
